import { memo } from "react";

import { AlertContainer } from "@components/molecules/alert";
import { ModalContainer } from "@components/modals/baseModal";

export const LayoutContainer = memo(function LayoutContainer() {
  return (
    <>
      <AlertContainer />
      <ModalContainer />
    </>
  );
});
